// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sign-out[data-v-039c5b43] {\n  margin: auto;\n}", ""]);
// Exports
module.exports = exports;
